export const getVideoDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const videoElement = document.createElement("video");
    videoElement.preload = "metadata";

    videoElement.onloadedmetadata = function () {
      window.URL.revokeObjectURL(videoElement.src);
      const durationInMilliseconds = Math.floor(videoElement.duration * 1000);
      resolve(durationInMilliseconds);
    };

    videoElement.onerror = function () {
      reject("Error loading video file");
    };

    videoElement.src = URL.createObjectURL(file);
  });
};
